import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { BootstrapInput } from '../../../../components/BootstrapInput'
import { Controller, useFormContext } from 'react-hook-form'
import { IntegrationDots } from '../../../shared/ui/integrationDots'
import { ProductCardCategoryModel } from '../../../../server/mpsklad_core/Models/MpCard/ProductCardCategoryModel'
import { useFormStyles } from '../../../shared/lib/hooks/useFormStyles'
import { useLazyEffect } from '../../../../hooks/commonHooks'
import { useCategoriesDiff } from '../lib/useCategoriesDiff'
import { DifferenceTooltip } from '../../../shared/ui/differenceTooltip'

// NOTE: This component is tightly coupled with ProductForm and is intended to be used strictly within its form context.
// It relies on the field structure and naming conventions defined in ProductForm.
// Therefore, it is located inside the form widget in the ui folder.

interface CategoriesDisplayProps {
  onClickHandler: () => void
}

export const CategoryDisplay = ({onClickHandler}: CategoriesDisplayProps) => {
  const classes = useFormStyles()
  const {control, watch, formState, trigger} = useFormContext()

  const diffCategoryName = useCategoriesDiff()

  const [
    ozonInclude,
    wildberriesInclude,
    yandexMarketInclude,
    ozonCategory,
    wildberriesCategory,
    yandexMarketCategory
  ] = watch([
    'ozon.include',
    'wildberries.include',
    'yandexMarket.include',
    'ozon.category',
    'wildberries.category',
    'yandexMarket.category'
  ])

  const includedIntegrations = [ozonInclude, wildberriesInclude, yandexMarketInclude]
  const values: (ProductCardCategoryModel | undefined)[] = [ozonCategory, wildberriesCategory, yandexMarketCategory]

  const anySelected = includedIntegrations.some(Boolean)

  const combinedValue = values
    .map(val => val?.name?.split('/').pop()?.trim() || '')
    .filter(Boolean)
    .join(' / ')

  useLazyEffect(async () => {
    if (formState.isSubmitted) {
      await trigger('categoriesDisplay')
    }
  }, [combinedValue])

  return (
    <Controller
      name="categoriesDisplay"
      control={control}
      defaultValue=""
      rules={{
        validate: () => {
          if (anySelected && !values.some(val => !!val?.name)) {
            return 'Выберите хотя бы одну категорию'
          }
          return true
        }
      }}
      render={({field, fieldState}) => (
        <Box>
          <Box display="flex" alignItems="center" className={classes.root}>
            <Typography variant="subtitle1" className={classes.label}>
              Категории
            </Typography>
            <IntegrationDots types="universal"/>
            {diffCategoryName && <DifferenceTooltip title={diffCategoryName}/>}
          </Box>
          <BootstrapInput
            {...field}
            fullWidth
            readOnly
            error={!!fieldState.error}
            inputProps={{style: {cursor: !anySelected ? 'not-allowed' : 'pointer'}}}
            disabled={!anySelected}
            onClick={() => {
              if (anySelected) {
                onClickHandler()
              }
            }}
            value={combinedValue}
            onChange={() => {}}
          />
          {fieldState.error && (
            <Typography color="error" variant="caption">
              {fieldState.error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  )
}